import React, { useContext, VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { VideoColumn } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';
import { contentFilter } from '/utils/functions';

const BlockVideo: VFC<BlockProps> = (props) => {
  const presentMode = useContext(PresentModeContext);
  const contextContent = contentFilter(
    props.blockContent.context,
    presentMode,
    props.presentOption,
  );

  props.setAnimationComplete(props.animationStep >= 1);

  return (
    <ArticleBlock
      {...props}
      contextContent={contextContent}
      offset={presentMode ? 1 : 3}
      titleCentered
      columns={(props.blockContent?.columns?.list || []).map(
        (column: ColumnContainerJson) => (
          <>
            {!column.hidden && column.name === 'video' && (
              <VideoColumn
                {...column.elements.video}
                blockId={props.blockId}
                blockTitle={props.blockContent.title?.content}
                present={!!presentMode}
                autoplay={props.animationStep === 1}
              />
            )}
          </>
        ),
      )}
    />
  );
};

BlockVideo.displayName = 'BlockVideo';
export default BlockVideo;
